// extracted by mini-css-extract-plugin
module.exports = {"ourClients":"OurClientsBlock-module--our-clients--a8hUI","header":"OurClientsBlock-module--header--2v05g","clientList":"OurClientsBlock-module--client-list--DTUfk"};